import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BaseComponent, HeaderComponent } from '../../components';
import { XeroDisplayComponent } from '../../components/header/xero-display/xero-display.component';
import { ShortenJobIdPipe, StatusLabelPipe } from '../../pipes';
import { UiModule } from './ui.module';
import {
  AuthenticationService,
  SnackbarService,
  XeroConnectionService,
  InvoiceService,
  ProcessorService,
  AuthInterceptor,
  TermsAndConditionsService,
  DialogService,
  ServicesService,
  RejectionsService
} from '../../services';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { JobUploaderService } from '../../services/standard/job-uploader.service';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    DropzoneModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  declarations: [
    ShortenJobIdPipe,
    StatusLabelPipe,
    HeaderComponent,
    XeroDisplayComponent,
    BaseComponent
  ],
  exports: [
    UiModule,
    FormsModule,
    HttpClientModule,
    DropzoneModule,
    RouterModule,
    ShortenJobIdPipe,
    StatusLabelPipe,
    CommonModule,
    ReactiveFormsModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthenticationService,
        SnackbarService,
        ProcessorService,
        TermsAndConditionsService,
        InvoiceService,
        ServicesService,
        JobUploaderService,
        DialogService,
        RejectionsService,
        XeroConnectionService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true
        }
      ]
    };
  }
}
